"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestInterceptorNoHeader = exports.errorRequestInterceptor = exports.requestInterceptor = void 0;
var tslib_1 = require("tslib");
var js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
var read_1 = require("../../commons/read");
var Settings_1 = tslib_1.__importDefault(require("../Settings"));
function requestInterceptor(config) {
    var _a = Settings_1.default.getInstance(), envAcronym = _a.envAcronym, theme = _a.theme;
    var token = js_cookie_1.default.get(envAcronym + "mp_tk");
    var request = read_1.verifyAuth(config, token);
    var pref = js_cookie_1.default.get(envAcronym + "mp_pref") ? JSON.parse(atob(js_cookie_1.default.get(envAcronym + "mp_pref"))) : { timezone: 'E. South America Standard Time', language: 'pt-BR', appearance: { theme: 'mundipagg', mode: 'light' } };
    request.headers['Accept-Language'] = pref.language;
    request.headers['X-Theme'] = theme;
    request.headers.Timezone = pref.timezone;
    return request;
}
exports.requestInterceptor = requestInterceptor;
function errorRequestInterceptor(error) {
    var body = read_1.handleBodyRequest(error);
    return Promise.reject(body);
}
exports.errorRequestInterceptor = errorRequestInterceptor;
function requestInterceptorNoHeader(config) {
    return config;
}
exports.requestInterceptorNoHeader = requestInterceptorNoHeader;
//# sourceMappingURL=requestInterceptor.js.map